export default __webpack_public_path__ + "static/media/profilePic-3.df4ceeb5.jpg";